<!-- Added 98% width to prevent scroll bar in parent mat-tab -->
<div class="singleCalculator" style="width:98%">
  <div class="calc-inner-padded calc-intro">
    <h2>Debt-to-Income Calculator</h2>
    <p class="customizer-text">
      {{ debtToIncomeCalcIntro }}
    </p>
  </div>

  <div class="calc-inner-padded calc-main">
    <div class="calculatorInputs flex justify-space-between">
      <div class="flex-col">
        <div class="form-group">
          <label for="annualIncome">Annual Income</label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input type="number" id="annualIncome" class="form-control" [(ngModel)]="annualIncome"
              (ngModelChange)="calculateDTI()" />
          </div>
        </div>

        <div class="form-group">
          <label for="mortgagePayment">Mortgage Payment</label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input type="number" id="mortgagePayment" class="form-control" [(ngModel)]="mortgagePayment"
              (ngModelChange)="calculateDTI()" />
          </div>
        </div>

        <div class="form-group">
          <label for="creditCardPayments">Min. Credit Card Payments</label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input type="number" id="creditCardPayments" class="form-control" [(ngModel)]="creditCardPayments"
              (ngModelChange)="calculateDTI()" />
          </div>
        </div>

        <div class="form-group">
          <label for="carLoanPayments">Car Loan Payments</label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input type="number" id="carLoanPayments" class="form-control" [(ngModel)]="carLoanPayments"
              (ngModelChange)="calculateDTI()" />
          </div>
        </div>

        <div class="form-group">
          <label for="studentLoanPayments">Student Loan Payments</label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input type="number" id="studentLoanPayments" class="form-control" [(ngModel)]="studentLoanPayments"
              (ngModelChange)="calculateDTI()" />
          </div>
        </div>

        <div class="form-group">
          <label for="alimonyPayments">Alimony/Child Support</label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input type="number" id="alimonyPayments" class="form-control" [(ngModel)]="alimonyPayments"
              (ngModelChange)="calculateDTI()" />

          </div>
        </div>

        <div class="form-group">
          <label for="secondaryHomeExpenses">Secondary Home Expenses</label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input type="number" id="secondaryHomeExpenses" class="form-control" [(ngModel)]="secondaryHomeExpenses"
              (ngModelChange)="calculateDTI()" />
          </div>
        </div>

        <div class="form-group">
          <label for="otherLoanPayments">Other Loan or Debt Payments</label>
          <div class="input-group">
            <span class="input-group-text">$</span>
            <input type="number" id="otherLoanPayments" class="form-control" [(ngModel)]="otherLoanPayments"
              (ngModelChange)="calculateDTI()" />
          </div>
        </div>
      </div>
    </div>

    <div class="results-section">
      <div class="calc-inner-padded" *ngIf="results.length > 0">
        <div class="row d-flex justify-content-between">
          <div class="col-md-6">
            <h4>Debt-to-Income Ratio</h4>
          </div>
          <div class="col-md-6 d-flex justify-content-end">
            <p class="mainResultValue">{{ dtiRatio }}%</p>
          </div>
        </div>
      </div>
    </div>
  </div>